import { render, staticRenderFns } from "./RegisterSuccess.vue?vue&type=template&id=7c751d05&scoped=true&"
import script from "./RegisterSuccess.vue?vue&type=script&lang=ts&"
export * from "./RegisterSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterSuccess.vue?vue&type=style&index=0&id=7c751d05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c751d05",
  null
  
)

export default component.exports